<template>
    <!-- 数组类型渲染
         @author: liuguisheng
         @date: 2019-11-25
    -->
  <render-form-item v-if="currentFormShow && isnNullRender"
                    :labelText="labelName"
                    :labelPosition="labelPosition"
                    :lineHeight="lineHeight"
                    :strong="strong"
                    :italic="italic"
                    :indent="indent"
                    :wrap="wrap"
                    :whereColor="whereColor"
                    :renderColor="renderColor">
    <!-- 值 -->
    <render-form-content :underline="isUnderline"
                         :italic="italic == 'value'"
                         :strong="strong == 'value'"
                         :content="renderCurrentModel"
                         :leftFilling="leftUnderlineLength"
                         :rightFilling="rightUnderlineLength"
                         :whereColor="whereColor"
                    :renderColor="renderColor">
    </render-form-content>
  </render-form-item>
</template>


<script>
/** 混入方法 ::: 
 *  @mixin mixRenderItemTemplateChild 预览表单子级混入
 */
import { mixRenderItemTemplateChild } from "@/mixins/render_item/mix_render_item_template_child.js";

export default {
  mixins: [ mixRenderItemTemplateChild ],
  computed: {
    /** @name 是否显示当前表单项
     *  @return {Boolean} { true:显示, false:隐藏 } 
     *  @author 王汝鹏
     *  @version 2020-01-04
     */
    currentFormShow() {
      // 1. 表单项配置 显示标记是否为显示
      // 2. 表单项配置 渲染区显示标记是否为显示
      // 3. 标签名称为空、内容为空、下划线为0时 隐藏表单项(去除空白占位)
      return this.isDisplay
          && this.showRule!=='form'
          && ( this.labelName 
            || this.renderCurrentModel
            || this.showUnderline)
    },
        /**
     * @name 空值是否渲染计算
     * @return { boolean }
     * @author liuguisheng
     * @version 2020-05-23 星期六
     */
    
    isnNullRender () {
      if ( this.nullRender == '0') {
        return this.renderCurrentModel ? true : false;
      }
      if ( this.nullRender == '1') {
        return true
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/render_item/RenderArray.vue